<template>
  <!-- :style="`height:${this.height}px`" -->
  <div class="carousel-box">
    <div
      class="carousel-box-prev"
      @click="clickPrev"
      @mouseenter="clear"
      style="font-size: 30px"
      v-if="imgs.length > 1"
    >
      <van-icon
        name="arrow-left"
        color="#547287"
        class="vanicon"
        @mouseleave="leave($event)"
      />
    </div>

    <div id="carousel-box-content">
      <div
        class="carousel-box-item"
        :class="{ active: index == carouselIndex }"
        name="carousel-box-item"
        v-for="(item, index) in imgs"
        :key="index"
      >
        <img
          :src="IMAGE_API + item.thumbnail"
          @click="goUrl(item)"
          :class="imgs.length < 3 ? 'imgBig' : ''"
        />
        <div class="mask"></div>
      </div>
    </div>
    <div
      class="carousel-box-next"
      @click="clickNext"
      @mouseenter="clear"
      style="font-size: 30px"
      v-if="imgs.length > 1"
    >
      <van-icon
        name="arrow"
        color="#547287"
        class="vanicon"
        @mouseleave="leave($event)"
      />
    </div>
    <div class="carousel-box-options">
      <div
        class="carousel-box-oprev"
        @click="clickPrev"
        @mouseenter="clear"
      ></div>
      <div
        class="carousel-box-onext"
        @click="clickNext"
        @mouseenter="clear"
      ></div>
    </div>
  </div>
</template>

<script>
// import { getDirection } from "@/utils/utils";
import { IMAGE_API } from "../request/api";
import { addClickCount } from "../request/request";
export default {
  name: "carousel",
  props: {
    imgs: {
      type: Array,
      default: [],
    },
    height: {
      type: Number,
      default: 320,
    },
  },
  computed: {
    // curHeight: {
    //   get() {
    //     return this.height;
    //   },
    //   set(val) {
    //     this.height = val;
    //   },
    // },
  },
  data() {
    return {
      carouselIndex: 0,
      IMAGE_API,
      // aleft: require("@/assets/images/carousel/carousel-aleft.png"),
      // aright: require("@/assets/images/carousel/carousel-aright.png"),
      // left: require("@/assets/images/carousel/carousel-left.png"),
      // right: require("@/assets/images/carousel/carousel-right.png"),

      timer: false,
      interval: false,
      startx: 0,
      starty: 0,
    };
  },
  watch: {
    carouselIndex(val) {
      this.$nextTick(() => {
        this.getTransformXList();
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.resizeing, false);
    this.$nextTick(() => {
      this.getTransformXList();
    });
    // this.start();
    let carouselBoxContent = document.getElementById("carousel-box-content");
    carouselBoxContent.addEventListener("touchstart", this.touchstart, false);
    carouselBoxContent.addEventListener("touchend", this.touchend, false);
  },
  methods: {
    leave(e) {
      e.target.classList.add('leave');
    },
    getTransformXList() {
      let boxEl = document.getElementById("carousel-box-content");
      let boxWidth = boxEl.getBoundingClientRect().width;
      let boxLeft = boxEl.getBoundingClientRect().left;
      let totalWidth = 0;
      let imgList = document.getElementsByName("carousel-box-item");

      let prevIndex =
        this.carouselIndex - 1 < 0
          ? imgList.length - 1
          : this.carouselIndex - 1;

      for (
        let index = this.carouselIndex;
        index < imgList.length + this.carouselIndex;
        index++
      ) {
        let cindex = index % imgList.length;
        const element = imgList[cindex];
        let imgTransformX = 0;
        if (element.style.transform !== "") {
          imgTransformX = parseFloat(
            element.style.transform
              .replace("translateX(", "")
              .replace("px)", "")
          );
        }
        let itemWidth = element.getBoundingClientRect().width;
        let imgLeft = element.getBoundingClientRect().left;
        let cimgLeft = imgLeft - boxLeft;
        let rWidth = ((boxWidth - itemWidth) / 2) * (7 / 9);

        let diff = 0;
        if (this.carouselIndex == cindex) {
          diff = (boxWidth - itemWidth) / 2;
          if (imgTransformX == 0) {
            if (cimgLeft < diff) {
              element.style.transform = `translateX(${diff}px) `;
            } else {
              element.style.transform = `translateX(${cimgLeft - diff}px) `;
            }
          } else {
            if (cimgLeft > diff) {
              let formx = imgTransformX - (cimgLeft - diff);
              element.style.transform = `translateX(${formx}px) `;
            } else {
              let formx = imgTransformX + (diff - cimgLeft);
              element.style.transform = `translateX(${formx}px)`;
            }
          }
          let children = element.children;
          for (let child = 0; child < children.length; child++) {
            const childItem = children[child];
            childItem.style.transform = "scale(1)";
            childItem.style.transformOrigin = "unset";
          }
        } else if (prevIndex == cindex) {
          diff = (boxWidth - itemWidth) / 2 - rWidth;
          if (cimgLeft > diff) {
            let formx = imgTransformX - (cimgLeft - diff);
            element.style.transform = `translateX(${formx}px) `;
          } else {
            let formx = imgTransformX + (diff - cimgLeft);
            element.style.transform = `translateX(${formx}px) `;
          }
          let children = element.children;
          for (let child = 0; child < children.length; child++) {
            const childItem = children[child];
            childItem.style.transform = "scale(0.7)";
            childItem.style.transformOrigin = "0 50%";
          }
        } else {
          if (totalWidth == 0) {
            diff = (boxWidth - itemWidth) / 2 + rWidth;
            totalWidth += diff;
          } else {
            totalWidth += itemWidth;
            diff = totalWidth;
          }
          if (cimgLeft < diff) {
            let formx = imgTransformX - (cimgLeft - diff);
            element.style.transform = `translateX(${formx}px) `;
          } else {
            let formx = imgTransformX + (diff - cimgLeft);
            element.style.transform = `translateX(${formx}px)  `;
          }
          let children = element.children;
          for (let child = 0; child < children.length; child++) {
            const childItem = children[child];
            childItem.style.transform = "scale(0.7)";
            childItem.style.transformOrigin = "100% 50%";
          }
        }
      }
    },
    clickPrev() {
      this.carouselIndex =
        this.carouselIndex - 1 < 0
          ? this.imgs.length - 1
          : this.carouselIndex - 1;
    },
    clickNext() {
      this.carouselIndex =
        this.carouselIndex + 1 > this.imgs.length - 1
          ? 0
          : this.carouselIndex + 1;
    },
    goUrl(item) {
      addClickCount(item.id).then(() => {});
      if (!item.link) {
        this.$notify({ type: "primary", message: "没有二级页面" });
      } else {
        location.href = item.link;
      }
    },
    resizeing() {
      if (!this.timer) {
        this.timer = true;
        setTimeout(() => {
          this.getTransformXList();
          this.timer = false;
        }, 400);
      }
    },
    clear() {
      clearInterval(this.interval);
      this.interval = false;
    },
    start() {
      if (!this.interval) {
        this.interval = setInterval(() => {
          this.clickNext();
        }, 3000);
      }
    },
    touchstart(e) {
      this.startx = e.touches[0].pageX;
      this.starty = e.touches[0].pageY;
    },
    touchend(e) {
      let endx = e.changedTouches[0].pageX;
      let endy = e.changedTouches[0].pageY;
      let direction = this.getDirection(this.startx, this.starty, endx, endy);
      switch (direction) {
        case 0:
          break;
        case 1:
          break;
        case 2:
          break;
        case 3:
          this.clear();
          this.clickNext();
          this.start();
          break;
        case 4:
          this.clear();
          this.clickPrev();
          this.start();
          break;
        default:
      }
    },
    getDirection(startx, starty, endx, endy) {
      var angx = endx - startx;
      var angy = endy - starty;
      var dis = endy - starty;
      var result = 0;

      //如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }

      var angle = this.getAngle(angx, angy);
      if (angle >= -135 && angle <= -45) {
        result = 1;
      } else if (angle > 45 && angle < 135) {
        result = 2;
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 3;
      } else if (angle >= -45 && angle <= 45) {
        result = 4;
      }
      if (result == 1 || result == 2) {
        if (Math.abs(dis) < 100) {
          return 0;
        }
      }
      return result;
    },
    getAngle(angx, angy) {
      return (Math.atan2(angy, angx) * 180) / Math.PI;
    },
  },
};
</script>

<style lang="less" scoped>
@v_width: 19.2vw;
@v_height: 10.8vh;

.carousel-box {
  width: 792 / @v_width;
  height: 320 / @v_width;
  display: flex;
  align-items: center;
  margin-top: 20px;

  .carousel-box-prev,
  .carousel-box-next {
    width: 56 / @v_width;
    height: 56 / @v_width;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }
  // .carousel-box-prev:hover{
  //   opacity: 1;
  //   color:#547287;
  // }
  // .carousel-box-next:hover{
  //   opacity: 1 !important;
  //   color:#547287;

  // }
  .vanicon {
    opacity: 0.2;
    &:hover {
      opacity: 1;
      transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);
    }
  }
  .leave {
    transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);
    // opacity: 0.2;
  }
  .carousel-box-prev {
    // background: url("../assets/images/carousel/carousel-left.png") no-repeat
    //   center center;
    background-size: contain;
    cursor: pointer;
    // &:hover {
    //   background: url("../assets/images/carousel/carousel-aleft.png")
    //     no-repeat center center;
    //   background-size: contain;
    // }
  }

  .carousel-box-next {
    // background: url("../assets/images/carousel/carousel-right.png") no-repeat
    //   center center;
    background-size: contain;
    cursor: pointer;
    // &:hover {
    //   background: url("../assets/images/carousel/carousel-aright.png")
    //     no-repeat center center;
    //   background-size: contain;
    // }
  }

  #carousel-box-content {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 1260px;
    height: 320 / @v_width;

    .carousel-box-item {
      min-width: 570 / @v_width;
      min-height: 320 / @v_width;
      display: flex;
      align-items: center;
      position: relative;
      transition: all 0.6s Cubic-Bezier(0.4, 0, 0.4, 1);
      z-index: 2;

      &.active {
        z-index: 3;

        .mask {
          display: none;
        }
      }

      .mask {
        position: absolute;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 11 / @v_width;
        width: 100%;
        height: 100%;
        transition: all 0.6s Cubic-Bezier(0.4, 0, 0.4, 1);
      }

      img {
        width: 801px;
        height: 343px;
        border-radius: 16px;
        box-shadow: 0px 9px 24px 0px rgba(0, 0, 0, 0.06);
        transition: all 0.6s Cubic-Bezier(0.4, 0, 0.4, 1);
      }
      .imgBig {
        width: 1195px;
      }
    }
  }

  .carousel-box-options {
    display: none;
  }
}
.btn.btn_next {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 40px;
  opacity: 0.5;
  position: absolute;
  right: -80px;
}
.btn > img {
  width: 100%;
  height: 100%;
  transition: all 0.6s Cubic-Bezier(0.4, 0, 0.4, 1);
}
</style>
